import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_restrooms_regularly_stocked_w_necessary_supplies'

export const dataPointDefinition = {
  retracedId: 'are_restrooms_regularly_stocked_w_necessary_supplies',
  name: 'Are restrooms regularly stocked with necessary supplies?',
  description:
    'Refers to supplies such as buckets of water, toilet paper, covered trash bins, and sanitary waste bins.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-5-6x',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 13610,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
